'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _DirectionalIcon = require('./DirectionalIcon');

var _DirectionalIcon2 = _interopRequireDefault(_DirectionalIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Triangle = function Triangle(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutProperties(_ref, ['fill']);

  return _react2.default.createElement(
    _DirectionalIcon2.default,
    props,
    _react2.default.createElement(
      'svg',
      { style: { display: 'block' }, xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', x: '0px', y: '0px', width: '100%', height: '100%', viewBox: '0 0 16 16' },
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('polygon', { fill: fill, points: '13,11 8,5 3,11' })
      )
    )
  );
};

Triangle.propTypes = _extends({}, _DirectionalIcon2.default.propTypes);

Triangle.defaultProps = _extends({}, _DirectionalIcon2.default.defaultProps);

exports.default = Triangle;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL1RyaWFuZ2xlLmpzIl0sIm5hbWVzIjpbIlRyaWFuZ2xlIiwiZmlsbCIsInByb3BzIiwiZGlzcGxheSIsInByb3BUeXBlcyIsImRlZmF1bHRQcm9wcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7Ozs7OztBQUVBLElBQU1BLFdBQVcsU0FBWEEsUUFBVyxPQUF3QjtBQUFBLE1BQXJCQyxJQUFxQixRQUFyQkEsSUFBcUI7QUFBQSxNQUFaQyxLQUFZOztBQUN2QyxTQUNFO0FBQUE7QUFBcUJBLFNBQXJCO0FBQ0U7QUFBQTtBQUFBLFFBQUssT0FBTyxFQUFFQyxTQUFTLE9BQVgsRUFBWixFQUFrQyxPQUFNLDRCQUF4QyxFQUFxRSxZQUFXLDhCQUFoRixFQUErRyxHQUFFLEtBQWpILEVBQXVILEdBQUUsS0FBekgsRUFBK0gsT0FBTSxNQUFySSxFQUE0SSxRQUFPLE1BQW5KLEVBQTBKLFNBQVEsV0FBbEs7QUFDRTtBQUFBO0FBQUE7QUFDRSxtREFBUyxNQUFNRixJQUFmLEVBQXFCLFFBQU8sZ0JBQTVCO0FBREY7QUFERjtBQURGLEdBREY7QUFTRCxDQVZEOztBQVlBRCxTQUFTSSxTQUFULGdCQUNLLDBCQUFnQkEsU0FEckI7O0FBSUFKLFNBQVNLLFlBQVQsZ0JBQ0ssMEJBQWdCQSxZQURyQjs7a0JBSWVMLFEiLCJmaWxlIjoiVHJpYW5nbGUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgRGlyZWN0aW9uYWxJY29uIGZyb20gJy4vRGlyZWN0aW9uYWxJY29uJ1xuXG5jb25zdCBUcmlhbmdsZSA9ICh7IGZpbGwsIC4uLnByb3BzIH0pID0+IHtcbiAgcmV0dXJuIChcbiAgICA8RGlyZWN0aW9uYWxJY29uIHsuLi5wcm9wc30+XG4gICAgICA8c3ZnIHN0eWxlPXt7IGRpc3BsYXk6ICdibG9jaycgfX0geG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJyB4bWxuc1hsaW5rPSdodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rJyB4PScwcHgnIHk9JzBweCcgd2lkdGg9JzEwMCUnIGhlaWdodD0nMTAwJScgdmlld0JveD0nMCAwIDE2IDE2Jz5cbiAgICAgICAgPGc+XG4gICAgICAgICAgPHBvbHlnb24gZmlsbD17ZmlsbH0gcG9pbnRzPScxMywxMSA4LDUgMywxMScgLz5cbiAgICAgICAgPC9nPlxuICAgICAgPC9zdmc+XG4gICAgPC9EaXJlY3Rpb25hbEljb24+XG4gIClcbn1cblxuVHJpYW5nbGUucHJvcFR5cGVzID0ge1xuICAuLi5EaXJlY3Rpb25hbEljb24ucHJvcFR5cGVzXG59XG5cblRyaWFuZ2xlLmRlZmF1bHRQcm9wcyA9IHtcbiAgLi4uRGlyZWN0aW9uYWxJY29uLmRlZmF1bHRQcm9wc1xufVxuXG5leHBvcnQgZGVmYXVsdCBUcmlhbmdsZVxuIl19


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Triangle.js
// module id = 591
// module chunks = 0